module.exports = __webpack_public_path__ + "static/media/show.6bf86602.JPG";